import { Model } from "@/models/base/model";
import { _$t } from "@/utils/i18n";

export class Profile extends Model {
  constructor(params: any = {}) {
    super(params);
    this.name = "Profile";
    this.url = "";

    this.validation = this.getValidationSchema();
    this.labels = this.getValidationLabels();
  }

  // プロフィール取得
  async getProfileInfo(): Promise<any> {
    this.url = "/cms/api/profile/info";
    return await super.fetch();
  }
  // 疾患情報取得
  async getAllDiseases(): Promise<any> {
    this.url = "/cms/api/profile/getdiseases";
    return await super.fetch();
  }
  // コンテンツタグ情報(関心のあるもの)取得
  async getInterestOptions(): Promise<any> {
    this.url = "/cms/api/profile/getinterests";
    return await super.fetch();
  }
  // プロフィール更新
  async updateProfile(params: any = {}) {
    this.url = "/cms/api/profile/update";
    return await this.save(params, "PUT");
  }

  // バリデーションのルールを定義
  getValidationSchema() {
    return {
      // メールアドレス（ログインID）
      userloginid: {
        type: "string",
        required: true,
        pattern: "email",
        maxLength: 50,
      },
      // 属性
      attribute: {
        required: true,
      },
      // 生年月日
      birthdate: {
        type: "string",
        required: true,
        pattern: "date",
        maxLength: 10,
      },
      // 郵便番号(前半)
      zipcode1: {
        type: "string",
        required: false,
        pattern: "number",
        maxLength: 3,
      },
      // 郵便番号(後半)
      zipcode2: {
        type: "string",
        required: false,
        pattern: "number",
        maxLength: 4,
      },
      // 病名
      diseasecodes: {
        required: false,
      },
      //nickname
      nickname: {
        type: "string",
        required: true,
        maxLength: 20,
      },
    };
  }

  // バリデーションエラー時のラベルを定義
  getValidationLabels() {
    return {
      userloginid: _$t("profile_mailaddress"),
      attribute: _$t("profile_edit_attibute"),
      birthdate: _$t("profile_edit_birthday"),
      zipcode1: _$t("profile_edit_zipcode"),
      zipcode2: _$t("profile_edit_zipcode"),
      gender: _$t("profile_edit_gender"),
      diseasecodes: _$t("profile_edit_disease_name"),
      nickname: _$t("profile_edit_nickname"),
    };
  }
}
